module.exports = __webpack_public_path__ + "static/media/qca.922eb122.gif";